import { register } from 'ol/proj/proj4';
import proj4 from 'proj4';

/*
 * 註冊幾個台灣常用的座標系統
 */

// TWD97 119中央經度(台灣本島)
proj4.defs(
    'EPSG:3825',
    '+proj=tmerc +lat_0=0 +lon_0=119 +k=0.9999 +x_0=250000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs',
);
// TWD97 121中央經度(台灣本島)
proj4.defs(
    'EPSG:3826',
    '+proj=tmerc +lat_0=0 +lon_0=121 +k=0.9999 +x_0=250000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs',
);

// TWD67 119中央經度(澎湖 / 金門)
proj4.defs(
    'EPSG:3827',
    '+proj=tmerc +lat_0=0 +lon_0=121 +k=0.9999 +x_0=250000 +y_0=0 +ellps=GRS67 +towgs84=-752,-358,-179,-0.0000011698,0.0000018398,0.0000009822,0.00002329 +units=m +no_defs',
);
// TWD67 121中央經度(澎湖 / 金門)
proj4.defs(
    'EPSG:3828',
    '+proj=tmerc +lat_0=0 +lon_0=121 +k=0.9999 +x_0=250000 +y_0=0 +ellps=GRS67 +towgs84=-752,-358,-179,-0.0000011698,0.0000018398,0.0000009822,0.00002329 +units=m +no_defs',
);
register(proj4);

export default proj4;
